import { TFunction } from 'i18next'
import { isEmpty } from 'lodash-es'
import { BaseErrorResponse } from 'types/beneficiaries'
import { ErrorCodes } from 'types/errorCodes'
import { ReportScheduleErrorList } from 'types/transactionsExport'

const getReportingServiceErrorMessage = (
  error: BaseErrorResponse | null,
  t: TFunction
): string | null => {
  if (!error?.data) return null

  const errorData = error.data

  switch (errorData.code) {
    case ErrorCodes.REPORT_LEDGER_DUPLICATE_REQUEST:
      return t('exports.duplicateRequestError')

    case ErrorCodes.REPORT_LEDGER_PDF_TRANSACTIONS_LIMIT_REACHED:
      return errorData.message

    case ErrorCodes.REPORT_LEDGER_WALLET_NOT_FOUND:
      return t('exports.walletNotFoundError')

    case ErrorCodes.UNSUPPORTED_TIME_PERIOD:
      return t('exports.unsupportedTimePeriodError')

    default:
      return t('oopsSomethingWentWrong')
  }
}

export const getScheduleErrorMessage = (
  postError: BaseErrorResponse | null,
  putError: BaseErrorResponse | null,
  isUpdate: boolean,
  t: TFunction
): string => {
  const postErrorList = postError?.data?.details?.errors as unknown as ReportScheduleErrorList
  const putErrorList = putError?.data?.details?.errors as unknown as ReportScheduleErrorList

  if (!isEmpty(postErrorList?.createOrUpdateReportScheduleRequest)) {
    return postErrorList?.createOrUpdateReportScheduleRequest?.[0]
  }

  if (!isEmpty(putErrorList?.createOrUpdateReportScheduleRequest)) {
    return putErrorList?.createOrUpdateReportScheduleRequest?.[0]
  }

  return isUpdate ? t('exports.updateReportScheduleError') : t('exports.createReportScheduleError')
}

export const getOnceOffExportErrorMessage = (
  sendTransactionsReportError: BaseErrorResponse | null,
  t: TFunction
): string => {
  if (sendTransactionsReportError) {
    const reportingServiceMessage = getReportingServiceErrorMessage(sendTransactionsReportError, t)
    if (reportingServiceMessage) return reportingServiceMessage
  }

  return t('oopsSomethingWentWrong')
}
